<template>
    <div :class="getCSSClass('person-picker-container')">
        <div :class="getCSSClass('person-picker-type-row')" v-if="groupField != ''">
            <template v-for="option in groupFieldOptions">
                <label><input type="radio" :value="option.value" v-model="groupFieldValue" style="margin-right: .5rem; white-space: nowrap">{{ translate(option.label) }}</label>
            </template>
        </div>
        <add-or-pick
                v-model="personId"
                :urls="typeUrls"
                :auto-emit="true"
                v-on:input="$emit('input', $event)"
                :label-property="'fullname'"
                :add-button-label="translate('Hozzáadás')"
        ></add-or-pick>
    </div>
</template>

<script>
    export default {
        inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],
        props: {
            urls: {},
            value: {},
            groupField: {type: String, default: 'is_agencyworker'},
            groupFieldOptions: {type: Array, default: () => {return [
                {value: 0, label: 'Munkatárs'},
                {value: 1, label: 'Külső együttműködő'},
            ]}}
        },
        data: function () {
            return {
                groupFieldValue: 0,
                personId: -1,
            }
        },
        mounted() {
            if (this.value) {
                this.personId = this.value;
            }
        },
        methods: {},
        computed: {
            currentPersonSelection: function() {
                return this.persons[this.groupFieldValue];
            },
            typeUrls: function() {
                let result = {};
                result['formUrl'] = this.urls[this.groupFieldValue].formUrl;
                result['storeUrl'] = this.urls[this.groupFieldValue].storeUrl;
                result['fetchUrl'] = this.urls[this.groupFieldValue].fetchUrl;

                let url = new URL(result.fetchUrl);
                url.searchParams.set(this.groupField, this.groupFieldValue);
                result.fetchUrl = url.toString();

                return result;
            }
        },
        watch: {
            groupFieldValue: function() {
                this.personId = -1;
                this.$emit('input', this.personId);
            },
            value: function() {
                this.personId = this.value;
            }
        }

    }
</script>
